import { FC } from 'react';
import {
  MobileAppStoreData,
  MobileAppStoresDisplayType,
  useMobileAppStores,
} from 'src/hooks/useMobileAppStores';

type Props = {
  displayType: MobileAppStoresDisplayType;
  AppStoreComponent: FC<MobileAppStoreData>;
};

export * from './ClickableStoreReviews';
export * from './VerticalStoreDownloadAndReviews';

export const MobileAppStores = ({ displayType, AppStoreComponent }: Props) => {
  const appStores = useMobileAppStores(displayType);

  return (
    <>
      {appStores.map(storeData => (
        <AppStoreComponent key={storeData.storeType} {...storeData} />
      ))}
    </>
  );
};
